module.exports = __webpack_public_path__ + "static/media/lazada-logo.e0d027f3.png";